<template>
  <div>
    <Ptable
      ref="childrenTable"
      :tabShow="'all'"
      :tableData="tableData"
      :totalNum="totalNum"
      :dialogVisible="dialogVisible"
      @handleClick="handleClick"
      @child-event="getLists"
      :loading="loading"
    ></Ptable>
  </div>
</template>

<script>
import Ptable from "../components/table.vue";
import { querySupplierMessagePageByOrgId } from "../api/all";
export default {
  components: {
    Ptable
  },
  data() {
    return {
      tableData: [],
      totalNum: 0,
      dialogVisible: false,
      dialogValue: null,
      loading: false
    };
  },
  activated() {
    this.getLists();
  },
  methods: {
    handleClick(row, value, form) {
      this.row = row;
      if (value.value === 1) {
        // this.$router.push({
        //   path: `/publicNotice/notice/detail`,
        //   query: { type: "detail", messageId: row.messageId }
        // });
      }
    },

    getLists(val) {
      querySupplierMessagePageByOrgId({
        ...val,
        isShowPageLoading: true
      }).then(res => {
        this.loading = true;
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
          this.loading = false;
        }
      });
    }
  }
};
</script>
